export const deriveWebp = (url?: string): string =>
  url && /\.(png|jpe?g)$/i.test(url) ? url.replace(/\.(png|jpe?g)$/i, '.webp') : url;
